// extracted by mini-css-extract-plugin
export var content = "simple-card-module--content--1pIoE";
export var hidden = "simple-card-module--hidden--pVjo1";
export var simpleCard = "simple-card-module--simple-card--KwZZi";
export var title = "simple-card-module--title--QqL-U";
export var visible = "simple-card-module--visible--J2hPm";